import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import InputsFromReplacement41_4aTable from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const InputsFromReplacement41_4a = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("INPUTS_FROM_REPLACEMENT") || "Inputs from replacement"}
        subDescription={t("INPUTS_FROM_REPLACEMENT_41_4A_DESC") || "These are the new product units, components, or materials brought in to replace parts that have reached end-of-life during use. They are needed to restore the product to full operational condition."}
        isNormal={true}
        number={"41.4a"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`inputs-from-replacement-41-4a-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <InputsFromReplacement41_4aTable productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default InputsFromReplacement41_4a;

